import parentPaths from '../../services/paths';

export const RESOURCE_URL = 'resourceURL';

export const CRUD_ENDPOINTS = [
  { id: '/catalogs', value: '/catalogs', path: parentPaths.catalogs },
  { id: '/consent-manager/consents', value: '/consent-manager/consents' },
  { id: '/contracts/partners', value: '/contracts/partners' },
  { id: '/dexter/logs', value: '/dexter/logs' },
  { id: '/email-builder/template-samples', value: '/email-builder/template-samples' },
  { id: '/geoip', value: '/geoip' },
  {
    id: '/license-manager/license-provider-definitions',
    value: '/license-manager/license-provider-definitions',
  },
  { id: '/license-manager/licenses', value: '/license-manager/licenses' },
  { id: '/payment-proxy/persisted-payments', value: '/payment-proxy/persisted-payments' },
  { id: '/payment-proxy/transactions', value: '/payment-proxy/transactions' },
  { id: '/service-example-golang/examples', value: '/service-example-golang/examples' },
  { id: '/service-example-java/examples', value: '/service-example-java/examples' },
  { id: '/stores', value: '/stores', path: parentPaths.stores },
  { id: '/subscription-manager/models', value: '/subscription-manager/models' },
  {
    id: '/subscription-manager/subscriptionModels',
    value: '/subscription-manager/subscriptionModels',
  },
  {
    id: '/subscription-manager/subscriptions',
    value: '/subscription-manager/subscriptions',
    path: parentPaths.subscriptions,
  },
  { id: '/subscriptions/models', value: '/subscriptions/models' },
  { id: '/subscriptions/subscriptions', value: '/subscriptions/subscriptions' },
  {
    id: '/subsidiary-manager/subsidiaries',
    value: '/subsidiary-manager/subsidiaries',
    path: parentPaths.subsidiaryManager.subsidiariesTab,
  },
  { id: '/tandcs', value: '/tandcs' },
  { id: '/tandcs/tandcs', value: '/tandcs/tandcs' },
  { id: '/tandcs/templates', value: '/tandcs/templates' },
  { id: '/tandcs/variables', value: '/tandcs/variables' },
  { id: '/vatcheck', value: '/vatcheck' },
  { id: '/vatengine', value: '/vatengine' },
  { id: '/zipcode', value: '/zipcode' },
  { id: '/assets', value: '/assets' },
  { id: '/audits/auditItems', value: '/audits/auditItems', path: parentPaths.audits },
  { id: '/billing-plan-manager/billing-plans', value: '/billing-plan-manager/billing-plans' },
  {
    id: '/campaigns/abandonedcarts',
    value: '/campaigns/abandonedcarts',
    path: parentPaths.campaigns.abandoned,
  },
  {
    id: '/campaigns/license-expiration-campaigns',
    value: '/campaigns/license-expiration-campaigns',
    path: parentPaths.campaigns.licenseExpiration,
  },
  { id: '/carts', value: '/carts', path: parentPaths.carts },
  { id: '/carts/public', value: '/carts/public' },
  {
    id: '/notification/definitions',
    value: '/notification/definitions',
    path: parentPaths.notifications.notificationDefinitionTab,
  },
  {
    id: '/notification/notifications',
    value: '/notification/notifications',
    path: parentPaths.notifications.notificationHistoryTab,
  },
  {
    id: '/notification/receivers',
    value: '/notification/receivers',
    path: parentPaths.notifications.notificationReceiversTab,
  },
  {
    id: '/referential-manager/currency',
    value: '/referential-manager/currency',
    path: parentPaths.referentialManager.currenciesTab,
  },
  {
    id: '/referential-manager/locale',
    value: '/referential-manager/locale',
    path: parentPaths.referentialManager.localesTab,
  },
  {
    id: '/referential-manager/country',
    value: '/referential-manager/country',
    path: parentPaths.referentialManager.countriesTab,
  },
  { id: '/customers', value: '/customers', path: parentPaths.customers },
  { id: '/customers/public', value: '/customers/public' },
  { id: '/designs/fonts', value: '/designs/fonts', path: parentPaths.checkoutpagebuilder.fontsTab },
  { id: '/designs/i18ns', value: '/designs/i18ns', path: parentPaths.localization.translationsTab },
  {
    id: '/designs/layouts',
    value: '/designs/layouts',
    path: parentPaths.checkoutpagebuilder.layoutsTab,
  },
  {
    id: '/designs/legali18ns',
    value: '/designs/legali18ns',
    path: parentPaths.localization.invoiceTranslationsTab,
  },
  {
    id: '/designs/themes',
    value: '/designs/themes',
    path: parentPaths.checkoutpagebuilder.themesTab,
  },
  { id: '/designs/visual-libraries', value: '/designs/visual-libraries' },
  { id: '/discounts', value: '/discounts', path: parentPaths.discountrules },
  { id: '/discounts/usages', value: '/discounts/usages' },
  { id: '/email-builder/operations', value: '/email-builder/operations' },
  {
    id: '/email-builder/template-definitions',
    value: '/email-builder/template-definitions',
    path: parentPaths.emailbuilder,
  },
  { id: '/email-builder/template-samples', value: '/email-builder/template-samples' },
  { id: '/endusers', value: '/endusers', path: [parentPaths.endusers, parentPaths.resellers] },
  { id: '/endusers/groups', value: '/endusers/groups', path: parentPaths.endusergroups },
  { id: '/fulfillments/fulfillments', value: '/fulfillments/fulfillments' },
  {
    id: '/fulfillments/partners',
    value: '/fulfillments/partners',
    path: parentPaths.fulfillment.autoFulfillmentsTab,
  },
  {
    id: '/products/customFieldsDefinition',
    value: '/products/customFieldsDefinition',
    path: parentPaths.customFieldsDefinition,
  },
  { id: '/iam/identities', value: '/iam/identities', path: parentPaths.users },
  { id: '/iam/meta-roles', value: '/iam/meta-roles', path: parentPaths.userroles.metaRoles },
  { id: '/iam/privileges', value: '/iam/privileges', path: parentPaths.userroles.privileges },
  { id: '/iam/realms', value: '/iam/realms' },
  { id: '/iam/roles', value: '/iam/roles', path: parentPaths.userroles.roles },
  { id: '/iam/roles/usableForIdentity', value: '/iam/roles/usableForIdentity' },
  { id: '/iam/tokens', value: '/iam/tokens' },
  { id: '/invoices/credits', value: '/invoices/credits' },
  { id: '/invoices/invoices', value: '/invoices/invoices' },
  { id: '/license-keys-provider/import', value: '/license-keys-provider/import' },
  {
    id: '/license-keys-provider/packages',
    value: '/license-keys-provider/packages',
    path: parentPaths.fulfillment.manualFulfillmentsTab,
  },
  {
    id: '/license-manager/license-provider-definitions',
    value: '/license-manager/license-provider-definitions',
    path: parentPaths.fulfillment.licenseProviderDefinitionsTab,
  },
  {
    id: '/license-manager/licenses',
    value: '/license-manager/licenses',
    path: parentPaths.licenses,
  },
  {
    id: '/marketing-campaign/campaigns',
    value: '/marketing-campaign/campaigns',
    path: parentPaths.campaigns.campaigns,
  },
  { id: '/onboarding', value: '/onboarding', path: parentPaths.onboarding },
  { id: '/orders', value: '/orders' },
  { id: '/ordersv2', value: '/ordersv2', path: parentPaths.orderlist },
  { id: '/ordersgs', value: '/ordersgs' },
  {
    id: '/marketplaces-orders',
    value: '/marketplaces-orders',
    path: parentPaths.marketplaceOrders,
  },
  { id: '/payment-proxy', value: '/payment-proxy' },
  { id: '/payment-proxy/available-payment-types', value: '/payment-proxy/available-payment-types' },
  { id: '/payment-proxy/orders-by-card-digits', value: '/payment-proxy/orders-by-card-digits' },
  { id: '/payment-proxy/payments', value: '/payment-proxy/payments' },
  { id: '/payment-proxy/service/config', value: '/payment-proxy/service/config' },
  { id: '/prices', value: '/prices', path: parentPaths.pricemodels.pricesTab },
  {
    id: '/products/price-functions',
    value: '/products/price-functions',
    path: parentPaths.pricemodels.pricefunctionsTab,
  },
  {
    id: '/product-recommendations',
    value: '/product-recommendations',
    path: parentPaths.recommendations,
  },
  { id: '/products', value: '/products', path: parentPaths.productlist },
  { id: '/products/descriptions', value: '/products/descriptions' },
  { id: '/purchases', value: '/purchases' },
  { id: '/remittables', value: '/remittables', path: parentPaths.remittables },
];
